import axiosInstance from "../axios/axiosInstance";

export const startVisit = async (visitId) => {
    const payload = {signal: new AbortController().signal};
    return axiosInstance.put(`/visit/start/${visitId}`, payload);
};

export const endVisit = async (visitId) => {
    const payload = {signal: new AbortController().signal};
    return axiosInstance.put(`/visit/end/${visitId}`, payload);
};

export const reVisit = async (visitId) => {
    const payload = {signal: new AbortController().signal};
    return axiosInstance.put(`/visit/revisit/update/${visitId}`, payload);
};


export const fetchVisits = async (patientId, page) => {
    const payload = {signal: new AbortController().signal};
    return axiosInstance.get(`/visit?patient_id=${patientId}&page=${page}`, payload);
};

/**
 * Daily visits for the authenticated doctor.
 * doctor_id is resolved on the backend from the Bearer token — do not send it.
 */
export const fetchDoctorDailyVisits = async ({
    date_at,
    statuses,
    page = 1,
    per_page = 20,
} = {}) => {
    const params = new URLSearchParams();
    if (date_at) params.set('date_at', date_at);
    params.set('page', String(page));
    params.set('per_page', String(per_page));
    if (Array.isArray(statuses) && statuses.length > 0) {
        statuses.forEach((status) => params.append('status[]', status));
    }

    const response = await axiosInstance.get(`/doctor/visit/daily?${params.toString()}`);
    return normalizeDoctorDailyResponse(response.data);
};

function normalizeDoctorDailyResponse(payload) {
    const nested = payload?.data;
    const body = nested && !Array.isArray(nested) && Array.isArray(nested.data)
        ? nested
        : payload;
    const list = Array.isArray(body?.data)
        ? body.data
        : Array.isArray(nested)
            ? nested
            : [];
    const meta = body?.meta ?? payload?.meta ?? {};
    const count = Number(body?.count ?? payload?.count ?? meta.total ?? list.length) || 0;

    return {
        visits: list,
        count,
        date_at: body?.date_at ?? payload?.date_at ?? null,
        doctor_id: body?.doctor_id ?? payload?.doctor_id ?? null,
        meta,
        links: body?.links ?? payload?.links ?? null,
        pagination: {
            current: Number(meta.current_page ?? payload?.current_page ?? 1) || 1,
            pageSize: Number(meta.per_page ?? payload?.per_page ?? 20) || 20,
            total: count,
        },
    };
}
export const fetchRevisits = async (patientId, page) => {
    const payload = {signal: new AbortController().signal};
    return axiosInstance.get(`/visit?patient_id=${patientId}&page=${page}&status[0]=revisit`, payload);
};

export const sendDateToServer = async (visitId, date) => {
    return axiosInstance.post(`/visit/revisit/${visitId}`, date);
};

export const uploadFiles = async (visitId, files) => {
    try {
        const response = await axiosInstance.post(`/visit/upload/${visitId}`, files, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const uploadRemark = async (visitId, editorContent) => {
    try {
        const response = await axiosInstance.post(`/visit/remark/${visitId}`, editorContent, {
            headers: {
                'Content-Type': 'form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};
